import React from 'react';
import * as css from './EmptyPage.css';
import {Button, getFontWeight, getPrimitive, getSpacing} from '@tickchak/react-share/app';
import BtnPlus from '../button/btnPlus/BtnPlus';

function EmptyPage({image, title, description, buttonText, onClick, dataCyName=undefined}: {image: string; title?: string; description?: string; buttonText: string; onClick: () => void; dataCyName?: string}) {

    return (
        <css.container>
            <css.image src={image}/>
            {title && <css.title>{title}</css.title>}
            {description && <css.description>{description}</css.description>}
            <Button
                variant='brand'
                data-cy={dataCyName ? `${dataCyName}Btn` : undefined}
                iconStart={<BtnPlus hasText={false} onClick={onClick} text={undefined} white={undefined} state={undefined} bsize={32} dataCyName={dataCyName} />}
                onClick={onClick}
                customStyle={{
                    backgroundColor: getPrimitive('yellows.yellow400'),
                    paddingInlineStart: getSpacing('spaceSm'),
                    fontWeight: getFontWeight('bold')
                }}
            >{buttonText}
            </Button>
        </css.container>
    );
}

export default EmptyPage;

